module.exports = __webpack_public_path__ + "img/0-lg.5f44f08a.jpg";